const { upgradeArray } = require('.')

const enumToConstant = enumValue => upgradeArray([ ...new Set(Object.values(enumValue)) ])
module.exports = enumToConstant
